import Icon from 'core/assets/icons';
// import Image from "core/components/Image";
import type { TIngredient } from "./../../store/types";

type TIngredientListItem = {
  ingredient: TIngredient;
  isSelected: boolean;
  selectIngredient: (ingredient: TIngredient) => void;
}

const IngredientListItem = ({
  ingredient,
  isSelected,
  selectIngredient,
}: TIngredientListItem) => (
  <div className="min-h-[52px]">
    <div
      className={`
        flex items-center gap-2 cursor-pointer px-4 py-2 h-full min-h-[52px]
        ${isSelected ? 'bg-orange-50' : 'bg-white'}
      `}
      onClick={() => selectIngredient(ingredient)}
    >
      {/*<Image
        src={ingredient.image}
        alt="ingredient"
        className="w-12 h-12 rounded-lg cursor-pointer border object-cover"
      />*/}
      <div className="w-full flex justify-between items-center cursor-pointer">
        <label className="block text-[14px] cursor-pointer">
          {ingredient.name}
        </label>
        <div>
          <img
            src={isSelected ? Icon.RecipeMinus : Icon.RecipePlus}
            alt="recipe plus"
          />
        </div>
      </div>
    </div>
  </div>
)

export default IngredientListItem
